const FIND_STORE_PATH = "find-store";

export const generateCountryPath = (slugifiedCountry: string): string =>
    `${FIND_STORE_PATH}/${slugifiedCountry}/`;

export const generateCityPath = (
    slugifiedCountry: string,
    slugifiedCity: string,
): string => `${FIND_STORE_PATH}/${slugifiedCountry}/${slugifiedCity}/`;
